package com.bikompanion.ui.install

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Download
import androidx.compose.material.icons.filled.IosShare
import androidx.compose.ui.graphics.vector.ImageVector
import com.bikompanion.ui.strings.BikompanionStrings

/** iOS only exposes notifications to a home screen app, so until then a watch could not alert anyone. */
internal val AppInstallOffer?.requiredForWatchAlerts: Boolean
    get() = this == AppInstallOffer.AddToHomeScreen

internal val AppInstallOffer.icon: ImageVector
    get() = when (this) {
        AppInstallOffer.AddToHomeScreen -> Icons.Default.IosShare
        is AppInstallOffer.OpenStore -> Icons.Default.Download
    }

internal fun AppInstallOffer.hint(strings: BikompanionStrings): String =
    when (this) {
        AppInstallOffer.AddToHomeScreen -> strings.installHintIos
        is AppInstallOffer.OpenStore -> strings.installHintAndroid
    }
